__turbopack_context__.v({
  "feedbackWrapper": "SubmitFeedback-module__1iVIxG__feedbackWrapper",
  "footerWrapper": "SubmitFeedback-module__1iVIxG__footerWrapper",
});
